import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ExpandedAccordionDict } from 'core/type/Details.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectExpandedAccordionFromDetailState } from 'component/page/detail/store/detail.selectors';
import { DetailContentOnToggleProps } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';

export enum FAQItemName {
    HowDoIBookAnActivity = 'How_Do_I_Book_An_Activity',
    WhoAndWhenDoIPay = 'Who_And_When_Do_I_Pay',
    HowDoVouchersWork = 'How_Do_Vouchers_Work',
    WhereCanIFindMyActivityBooking = 'Where_Can_I_Find_My_Activity_Booking',
    HowCanICancelMyBooking = 'How_Can_I_Cancel_My_Booking',
    WhenWillIReceiveTheRefundForCancelledBookings = 'When_Will_I_Receive_The_Refund_For_Cancelled_Bookings',
}

interface StateProps {
    cms: CmsValue;
    expandedAccordion: ExpandedAccordionDict;
}

export interface FAQItemProps {
    input: string;
    output: string;
    itemName: FAQItemName;
}

export type FAQSectionProps = DetailContentOnToggleProps & StateProps;
export type FAQSectionModularProps = StateProps;

export const mapFAQSectionProps = createSelector(selectCmsFromBootstrap, selectExpandedAccordionFromDetailState, (cms, expandedAccordion) => {
    return { cms, expandedAccordion };
});
